import { render, staticRenderFns } from "./RawMaterialsOutput.vue?vue&type=template&id=22d603b7&"
import script from "./RawMaterialsOutput.vue?vue&type=script&lang=js&"
export * from "./RawMaterialsOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports